module.exports = __webpack_public_path__ + "img/share.abf1b9dc.svg";